export enum STEPS {
  SELECT_TYPE = 0,
  ADD_INFO = 1,
  UPLOAD_VIDEO = 2,
}
